import React, { useEffect, useState } from 'react';
import { EffectFade, Navigation, Autoplay } from 'swiper';
import PageBanner from '../../CommonPages/PageBanner';
import { Swiper, SwiperSlide } from "swiper/react";
import ProjectDetailsSlider from '../ProjectDetailsSlider';
import SectionGridLines from '../../CommonPages/SectionGridLines';
import { Outlet } from 'react-router-dom';
import MyLoader from '../../Shared/MyLoader';

const CosmeticDentalCare = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate an API call
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);
    }, []);

    if (isLoading) {
        // return <Loader/>;
        return <MyLoader />
    }
    return (
        <div>
            <main className="wrapper">
                <SectionGridLines />
                <Outlet />
                <PageBanner pageTitle='Projects' subpath='/projects' title="Cosmetic Dental Care" activePage="Cosmetic Dental Care" />
                <section className="project-details bg-dark-200">
                    <div className="container">
                        <div className="gallery_slider">
                            <div className="swiper swiper_gallery">
                                <Swiper
                                    modules={[EffectFade, Navigation, Autoplay]}
                                    effect="slide"
                                    slidesPerView={1}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                    navigation={{
                                        prevEl: '.swiper-button-prev',
                                        nextEl: '.swiper-button-next',
                                    }}
                                >

                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare1.webp' />
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare2.webp' />
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare3.webp' />
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare4.webp' />
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare5.webp' />
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare6.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare7.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare8.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare9.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare10.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare11.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Commercial/CosmeticDentalCare/cosmeticdentalcare12.webp' />
                                    </SwiperSlide>
                                </Swiper>

                                {/* <!-- Add Buttons --> */}
                                <div className="swiper-navigation">
                                    <div className="swiper-button-prev"><i className="bi bi-arrow-left"></i></div>
                                    <div className="swiper-button-next"><i className="bi bi-arrow-right"></i></div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4 col-md-4">

                                <div className="sidebar">
                                    <div className="project-information">
                                        <h6 className="widget-title">
                                            Project Information
                                            <span className="title-line"></span>
                                        </h6>
                                        <ul>
                                            <li>
                                                <span className="data">Client :</span> <span className="value">Dr. Bhushan Kalaria</span>
                                            </li>
                                            <li>
                                                <span className="data"> Area :</span> <span className="value">1400 Sqft</span>
                                            </li>
                                            <li>
                                                <span className="data">Location :</span> <span className="value">Rajkot,Gujarat</span>
                                            </li>
                                            <li>
                                                <span className="data">Photography :</span> <span className="value">Bhavik Shah</span>
                                            </li>
                                            <li>
                                                <span className="data">Text :</span> <span className="value">Nishal Sevak</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8 col-md-8">

                                <div className="project-details_inner">
                                    <div className="post_content">
                                        <div className="post-header">
                                            <h3 className="post-title">Cosmetic Dental Care</h3>
                                        </div>
                                        <div className="fulltext">
                                            <p>
                                                In a world where dental clinics evoke anxiety with sterile white corridors, Cosmetic Dental Care emerges as a breath of fresh air, quite literally. Nestled in Rajkot, this space challenges the very DNA of clinical design, transforming what might be a distressing experience into a journey of comfort and calm. The ideology was simple yet revolutionary: why should healthcare spaces feel clinical? The design philosophy pivoted away from the conventional hospital aesthetic, instead entwining warmth, nature, and hospitality. The vision was to create a cosy sanctuary where patients feel at ease the moment they cross the threshold, where waiting doesn&#39;t feel like an ordeal, and where healing begins before treatment does. The design concept weaves together three powerful elements: connection with nature, comfort through thoughtful spatial planning, and serenity through a carefully curated colour palette. Soft blue tones flow throughout the clinic like a gentle stream, evoking trust and tranquillity while maintaining a sophisticated modern edge. Cosmetic Dental Care proves that clinical spaces need not feel clinical. By challenging conventions and prioritising patient psychology alongside medical functionality, the design creates an environment where healing begins in the waiting room, continues through consultation, unfolds during treatment, and lingers in memory long after the visit ends.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default CosmeticDentalCare
